import { Component, NgZone, TemplateRef, ViewChild } from '@angular/core';
import {
  ActivatedRoute,
  ActivationEnd,
  NavigationEnd,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogService } from './services/dialog.service';
import { ScrollStrategy, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { VideoPlayerComponent } from './generic/video-player/components/video-player/video-player.component';
import { VideoService } from './services/video.service';
import { CampusFile } from 'src/openapi';
import { Title } from '@angular/platform-browser';
import { filter, first, map } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    '(document:keydown.escape)': 'handleKeyboardEvent($event)',
  },
})
export class AppComponent {
  dialogRef: MatDialogRef<any>;
  title = 'campus-online-frontend';

  videoShowing: boolean = false;
  videoHtml: string = '';
  videoError: boolean = false;

  loadingRouteConfig: boolean;

  @ViewChild('dialog', { static: true }) dialog: TemplateRef<any>;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private matDialog: MatDialog,
    private dialogService: DialogService,
    private videoService: VideoService,
    private titleService: Title
  ) {}

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.loadingRouteConfig = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.loadingRouteConfig = false;
      }
    });

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          while (child) {
            if (child.firstChild) {
              child = child.firstChild;
            } else if (child.snapshot.data && child.snapshot.data['title']) {
              return child.snapshot.data['title'];
            } else {
              return null;
            }
          }
          return null;
        })
      )
      .subscribe((data: any) => {
        if (data) {
          this.titleService.setTitle(`Tper elearning - ${data}`);
        } else {
          this.titleService.setTitle(`Tper elearning`);
        }
      });

    this.dialogService.registerDialogContainer(this);
    this.videoService.registerVideoContainer(this);
  }

  showDialog(title: string, message: string | TemplateRef<any>, style: string, actions: any, templateContext?: any) {
    this.dialogRef = this.matDialog.open(this.dialog, {
      data: {
        title: title,
        message: typeof message === 'string' ? message : undefined,
        template: !(typeof message === 'string') ? message : undefined,
        templateContext: templateContext,
        actions: actions,
        style: style,
      },
      autoFocus: false,
      hasBackdrop: true,
      disableClose: false,
      maxHeight: '90vh',
    });
  }

  showVideo() {
    this.videoShowing = true;
  }

  videoLoaded(response: { success: string; error: boolean }) {
    this.videoError = response.error;
    this.videoHtml = response.success;
  }

  closeVideo() {
    this.videoShowing = false;
    this.videoError = false;
    this.videoHtml = '';
  }

  videoShowingChange(open: boolean) {
    if (!open) {
      this.closeVideo();
    }
  }

  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.videoShowing && (event.key == 'Esc' || event.key == 'Escape')) {
      this.closeVideo();
      event.preventDefault();
    }
  }

  closeDialog() {
    this.matDialog.closeAll();
  }

  executeDialogAction(action: () => void) {
    if (action) {
      action();
    }

    this.closeDialog();
  }
}
